import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../firebaseConfig";
import {
  collection,
  getDocs,
  orderBy,
  query,
  where,
  updateDoc,
  doc,
} from "firebase/firestore";

export const fetchData = createAsyncThunk("data/fetchData", async () => {
  const ref = collection(db, "saving");
  const q = query(ref, orderBy("date", "desc"));
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
});

export const searchData = createAsyncThunk(
  "data/searchData",
  async (searchTerm) => {
    const ref = collection(db, "students");
    const q = query(ref, where("name", "==", searchTerm), orderBy("no", "asc"));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  }
);



export const editStudent = createAsyncThunk(
  "data/editStudent",
  async ({ id, data }) => {
    const ref = doc(db, "students", id);
     await updateDoc(ref, data);
  }
);

export const editSaving = createAsyncThunk(
  "data/editSaving",
  async ({ id, data }) => {
    const ref = doc(db, "saving", id);
     await updateDoc(ref, data);
  }
);

export const dataSlice = createSlice({
  name: "data",
  initialState: {
    isLoading: false,
    data: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(searchData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(searchData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(searchData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
  },
});
export default dataSlice.reducer;
